export const defaultExpandableChildren = {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    id: 'builder-9789fb144d544583a291dfd81b4f7c12',
    children: [
        {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            id: 'builder-bc2e6c73de594bc0bd9c57d6dd09f6d2',
            component: {
                name: 'Text',
                options: {
                    text: 'Everything in this box is expandable'
                }
            }
        },
        {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            id: 'builder-e3dbe713c24a4424b5648c0bab9f3288',
            component: {
                name: 'Image',
                options: {
                    image: 'https://cdn.builder.io/api/v1/image/assets%2F481825b100e64e7f9a22a215d86e03f1%2Ff119225d35264b43b9417b1565ea2612',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    lazy: false,
                    fitContent: true,
                    aspectRatio: 0.666,
                    lockAspectRatio: false,
                    height: 1331,
                    width: 2000
                }
            },
            responsiveStyles: {
                large: {
                    position: 'relative',
                    minHeight: '20px',
                    minWidth: '20px',
                    overflow: 'hidden',
                    width: '500px'
                },
                small: {
                    width: '100%'
                }
            }
        }
    ],
    responsiveStyles: {
        large: {
            paddingTop: '20px',
            paddingLeft: '20px',
            paddingBottom: '20px',
            paddingRight: '20px',
            borderWidth: '2px',
            borderStyle: 'solid'
        }
    }
}
